import { Component, OnInit, OnChanges, SimpleChanges, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { Bondsman } from '../bondsman';
import { HtmlUtil } from '../../shared/html-util';
import { BondsmanIdentifier } from '../../shared/bondsman-identifier';
import { EventService } from '../../shared/event.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-bondsman-search-results-table',
  templateUrl: './bondsman-search-results-table.component.html',
  styleUrls: ['./bondsman-search-results-table.component.less']
})
export class BondsmanSearchResultsTableComponent implements OnInit, OnChanges, OnDestroy {
  // TODO: check if it is needed to extend BaseSearchResultTable???

  @Input() Bondsman: Bondsman[];
  @Input() errors: string[];
  @Input() requestIsInFlight: boolean;

  mouseOverBondsmanFlags: boolean[];
  lastViewedBondsman: BondsmanIdentifier;
  subscriptions: Subscription[] = [];
  private previousURLincludedDetailsView = false;

  constructor(private cd: ChangeDetectorRef,
              private eventService: EventService,
              private router: Router
            ) {
    this.subscriptions.push(
        router.events.subscribe(theRoute => {
            if (theRoute instanceof NavigationEnd) {

                // When navigating from details view back to list, request focus on the last viewed bondsman
                const currentURLincludedDetailsView = this.doesURLIncludeBondsmanDetailsView(router.url);
                if (this.previousURLincludedDetailsView && !currentURLincludedDetailsView) {
                    setTimeout(() => {
                        this.requestFocusForLastViewedBondsman();
                    }, 0);
                }
                this.previousURLincludedDetailsView = router.url.indexOf('view:bondsman') > -1;

                const url = theRoute.urlAfterRedirects;
                if (url.indexOf('view:bondsman/') !== -1) {
                    const outlet = url.substring(url.indexOf('view:bondsman/'), url.indexOf(')'));
                    const parts: string[] = outlet.split('/');
                    this.lastViewedBondsman = new BondsmanIdentifier(parts[1]);
                    // tslint:disable-next-line:radix
                    this.lastViewedBondsman.setStateLicenseId(parseInt(parts[2]));
                }
            }
        })
    );
   }

  ngOnInit() {
  }

  ngOnDestroy() {
    for (let subscription of this.subscriptions) {
        subscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['Bondsman'] && this.Bondsman && this.Bondsman.length) {
      this.mouseOverBondsmanFlags = new Array(this.Bondsman.length).fill(false, 0, this.Bondsman.length);
      setTimeout(() => {
        this.focusViewBondsmanLink();
      }, 0);
    }
  }

  private doesURLIncludeBondsmanDetailsView(url: string) {
    return url.indexOf('view:bondsman') > -1;
  }

  private focusViewBondsmanLink() {
    let firstfocusedEleId: string = 'bondsman-search-results-row-' + 0 + '-bondsman-action-view-bondsman-lnk';
    let firstFocusedEle: HTMLElement = document.getElementById(firstfocusedEleId);
    if (firstFocusedEle) {
      setTimeout(() => {
        firstFocusedEle.focus();
      }, 0);
    }
   }

   protected requestFocusForLastViewedBondsman() {
    this.focusViewBondsmanLink();
   }

   onViewBondsmanSelected(bondsmanIdentifer: BondsmanIdentifier): void {
    this.router.navigate(
        [{outlets: {
            view: ['bondsman', bondsmanIdentifer.licenseNumber, bondsmanIdentifer.stateLicenseId]
        }}]);
   }

   isBondsmanLastViewed(bondsmanIdentifier: BondsmanIdentifier): boolean {
    if (bondsmanIdentifier == null || bondsmanIdentifier === undefined) {
        return false;
    }
    return bondsmanIdentifier.equals(this.lastViewedBondsman);
  }

   /**
    * listener for mouse over the bondsman row
    * @param i  the index of the row (i.e the index of the bondsman)
    */
   onMouseOverBondsman(i: number) {
    this.mouseOverBondsmanFlags[i] = true;
  }

  /**
   * listener for mouse off the bondsman row
   * @param i the index of the row (i.e the index of the bondsman)
   */
  onMouseOffBondsman(i: number) {
     this.mouseOverBondsmanFlags[i] = false;
  }

  /**
    * To resolve popover flicking issue upon mouse over/leave, hide or not the window scrollbar
    * @param type string
   */
  public popOverHandler(type: string) {
    HtmlUtil.popOverHandler(type);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bondsman-search-results-table/bondsman-search-results-table.component.ts